import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Navigation from './components/Navigation';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Course from './pages/Course';
import Register from './pages/Register';
import RaceGuide from './pages/RaceGuide';
import BookDrops from './pages/BookDrops';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/course" element={<Course />} />
            <Route path="/register" element={<Register />} />
            <Route path="/race-guide" element={<RaceGuide />} />
            <Route path="/book-drops" element={<BookDrops />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
